import {ArrayToStringPipe} from './pipes/array-to-string.pipe';
import {ErrorHandler, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {
    AdaptTooltipModule,
    AdaptModalModule,
    AdaptEmptyStateModule,
    AdaptToastModule,
    AdaptBusyModule,
    AdaptPaginationModule,
    AdaptButtonModule,
    AdaptRxTextareaModule,
    AdaptRxCheckboxModule,
    AdaptAlertModule,
    AdaptRxSearchModule,
    AdaptPopoverModule,
    AdaptDropdownModule,
    AdaptAdvancedFilteringModule,
    AdaptListKeyManagerModule,
    AdaptSubnavModule, AdaptRxRadiobuttonModule, AdaptRxDatetimeModule
} from '@bmc-ux/adapt-angular';
import {NormalizeDatePipe} from './pipes/normalize-date.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AcmAdminError} from './errors/acm-admin.error';
import {ErrorComponent} from './components/error/error.component';
import {AdaptNotFoundModule} from '@bmc-ux/adapt-angular';
import {MainPrimeNgTableComponent} from './components/main-primeng-table/main-primeng-table.component';
import {AdaptTableModule} from '@bmc-ux/adapt-table';
import {AllBmcProductsTableComponent} from './components/all-bmc-products-table/all-bmc-products-table.component';
import {AcmCutFieldNamePipe} from './pipes/acm-cut-field-name.pipe';
import {ProductTabTitleComponent} from './components/product-tab-title/product-tab-title.component';
import {UnderlineMatchPipe} from './pipes/underline-match.pipe';
import {UnauthorizedAccessComponent} from './components/unauthorized-access/unauthorized-access.component';
import {FeedbackComponent} from './components/feedback/feedback-form/feedback.component';
import {AcmCutUnderscorePipe} from './pipes/acm-cut-underscore.pipe';
import {FeedbackTableComponent} from './components/feedback/feedback-table/feedback-table.component';
import {HighlightMatchPipe} from './pipes/highlight-match.pipe';
import {ProductHistoryComponent} from './components/product-history/product-history.component';

const PIPES = [
  NormalizeDatePipe,
  AcmCutFieldNamePipe,
  ArrayToStringPipe,
  UnderlineMatchPipe,
  AcmCutUnderscorePipe,
  HighlightMatchPipe
];
const EXPORTED_MODULES = [
  HttpClientModule,
  AdaptTooltipModule,
  AdaptModalModule,
  AdaptEmptyStateModule,
  AdaptNotFoundModule,
  FormsModule,
  ReactiveFormsModule,
  AdaptToastModule,
  AdaptBusyModule,
  AdaptPaginationModule,
  AdaptPopoverModule,
  AdaptDropdownModule
];

@NgModule({
  declarations: [
    PIPES,
    ErrorComponent,
    MainPrimeNgTableComponent,
    AllBmcProductsTableComponent,
    ProductTabTitleComponent,
    FeedbackComponent,
    UnauthorizedAccessComponent,
    FeedbackTableComponent,
    ProductHistoryComponent
  ],
    imports: [
        CommonModule,
        ...EXPORTED_MODULES,
        AdaptTableModule,
        AdaptButtonModule,
        AdaptRxTextareaModule,
        AdaptRxCheckboxModule,
        AdaptAlertModule,
        AdaptRxSearchModule,
        AdaptAdvancedFilteringModule,
        AdaptListKeyManagerModule,
        AdaptSubnavModule,
        AdaptRxRadiobuttonModule,
        AdaptRxDatetimeModule
    ],
  exports: [
    ...EXPORTED_MODULES,
    ...PIPES,
    MainPrimeNgTableComponent,
    AllBmcProductsTableComponent,
    ProductTabTitleComponent,
    FeedbackComponent,
    FeedbackTableComponent,
    ProductHistoryComponent
  ],
  providers: [{
    provide: ErrorHandler,
    useClass: AcmAdminError
  }]
})
export class SharedModule {
}
